// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 树形实体层级枚举 枚举类
 * 树形实体的最大层级枚举
 */
export enum EnumTreeEntityLevel {
  /** 两级 : 两级 */
  Level2 = 1,
  /** 三级 : 三级 */
  Level3 = 2,
  /** 四级 : 四级 */
  Level4 = 4,
  /** 五级 : 五级 */
  Level5 = 8
}

/**
 * 树形实体层级枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumTreeEntityLevelMD {
  private static items = [
    new EnumItemMD('Level2', 1, '两级', '两级'),
    new EnumItemMD('Level3', 2, '三级', '三级'),
    new EnumItemMD('Level4', 4, '四级', '四级'),
    new EnumItemMD('Level5', 8, '五级', '五级')
  ];

  static getItem(enumItem: EnumTreeEntityLevel) {
    return this.items.find(item => item.name === EnumTreeEntityLevel[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
